import { render, staticRenderFns } from "./FreightTableCreateView.vue?vue&type=template&id=1353d703&scoped=true"
import script from "./FreightTableCreateView.vue?vue&type=script&lang=js"
export * from "./FreightTableCreateView.vue?vue&type=script&lang=js"
import style0 from "./FreightTableCreateView.vue?vue&type=style&index=0&id=1353d703&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353d703",
  null
  
)

export default component.exports